// extracted by mini-css-extract-plugin
export var dividerContainer = "_74-0";
export var line = "_74-1";